import { IEventsStore } from '../../store/player/events/store';

export const getTeamGameIndex = (
  events: IEventsStore,
  eventId: string | undefined,
  roundId: string | undefined,
  groupId: number,
  teamId: number
) => {
  if (!eventId || !roundId) {
    return 0;
  }

  const event = events[Number(eventId)];

  const round = event.rounds.find(eventRound => eventRound.id === Number(roundId));

  if (!round) {
    return 0;
  }

  const group = round.groups.find(roundGroup => Number(roundGroup.id) === groupId);

  if (!group) {
    return 0;
  }

  const result =
    group.games.reduce(
      (acc, game) =>
        game.enrollment.team === teamId && game.enrollment.index
          ? game.enrollment.index + acc
          : acc,
      0
    ) / group.games.length;

  return Number(result.toFixed(1));
};
